import Marquee from "react-fast-marquee";

const ITEMS = [
  "Feito com amor",
  "Produção artesanal",
  "Ingredientes selecionados",
  "Encomende e receba",
];

const TrustMarquee = () => {
  return (
    <div className="bg-choco text-cream py-6 border-y border-cream/10 editorial-marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="mx-10 font-serif italic text-2xl sm:text-3xl text-cream/90">{t}</span>
            <span className="text-gold text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default TrustMarquee;
